import React, { useState, useEffect } from 'react';
import ActionResult from '../components/ActionResult.js';
import TwoStepConfirmationButton from '../components/TwoStepConfirmButton.js';
import RichTable from '../components/richTable/RichTable.jsx';

function CircuitBreaker(props) {

    const [planInfo, setPlanInfo] = useState(null);
    const [result, setResult] = useState(null);
    const [updates, setUpdates] = useState(0);
    const [planLimits, setPlanLimits] = useState([]);

    useEffect(() => {
        (async function () {
            const query = `/api/planCircuitBreaker?planId=` + props.planId
            let result = await (await fetch(query)).json();
            console.log("planCircuitBreakers", result);
            if (result && result.success && result.circuitBreaker) {
                setPlanInfo(result.circuitBreaker);
            } else {
                setPlanInfo(null);
            }

            const limitsQuery = `/api/planLimits?planId=` + props.planId
            let limits = await (await fetch(limitsQuery)).json();
            console.log("planLimits", limits);
            if (limits && limits.success && limits.limits) {
                setPlanLimits(limits.limits);
            } else {
                setPlanLimits([]);
            }
        })();
    }, [props.planId, updates]);

    function shouldAllowEdits() {
        if (props.role === 3) return true;
        if (props.userId === planInfo.userIdOwner) return true;
        return false;
    }

    async function updateCircuitBreaker() {

        if (shouldAllowEdits()) {

            console.log("Validating input", planInfo);

            let absoluteThreshold = parseFloat(planInfo.dd_absolute_threshold);
            let differenceStartLevel = parseFloat(planInfo.dd_difference_start_level);
            let differenceEntryThreshold = parseFloat(planInfo.dd_difference_entry_threshold);
            let differenceExitThreshold = parseFloat(planInfo.dd_difference_exit_threshold);
            let differenceSmoothingDays = parseInt(planInfo.dd_difference_smoothing_days);
            let scaleRatio = parseFloat(planInfo.scale_ratio);
            let minimumTriggeredDays = parseInt(planInfo.minimum_triggered_days);
            let movingAverageEntryThreshold = parseFloat(planInfo.moving_average_entry_threshold);

            if (absoluteThreshold < 0 && differenceStartLevel < 0 && differenceEntryThreshold <= 0 &&
                differenceExitThreshold >= 0 && differenceSmoothingDays >= 1 && scaleRatio >= 0 && scaleRatio <= 1 &&
                minimumTriggeredDays >= 0
            ) {

                let query = `/api/planCircuitBreakerUpdate?planId=` + props.planId
                query += "&isEnabled=" + (planInfo.is_enabled ? "true" : "false")
                query += "&absoluteThreshold=" + (absoluteThreshold.toFixed(2))
                query += "&differenceStartLevel=" + (differenceStartLevel.toFixed(2))
                query += "&differenceEntryThreshold=" + (differenceEntryThreshold.toFixed(2))
                query += "&differenceExitThreshold=" + (differenceExitThreshold.toFixed(2))
                query += "&differenceSmoothingDays=" + (differenceSmoothingDays)
                query += "&scaleRatio=" + (scaleRatio.toFixed(2))
                query += "&minimumTriggeredDays=" + (minimumTriggeredDays)
                query += "&shouldExitOnNewHigh=" + (planInfo.should_exit_on_new_high ? "true" : "false")
                query += "&movingAverageEntryThreshold=" + (movingAverageEntryThreshold.toFixed(0))

                let result = await (await fetch(query, { method: 'POST' })).json();
                setResult(result);
                setUpdates(updates + 1);

            } else {
                setResult({ error: "Invalid settings" });
            }
        } else {
            setResult({ error: "Not allowed" });
        }
    }

    function updateSetting(name, value) {
        console.log("Updating " + name + " to " + value)
        let newSettings = JSON.parse(JSON.stringify(planInfo))
        newSettings[name] = value;
        setPlanInfo(newSettings);
    }

    async function addCircuitBreaker() {
        if (shouldAllowEdits()) {
            let query = `/api/planCircuitBreakerAdd?planId=` + props.planId
            let result = await (await fetch(query, { method: 'POST' })).json();
            setResult(result);
            setUpdates(updates + 1);
        } else {
            setResult({ error: "Not allowed" });
        }
    }

    async function removeCircuitBreaker() {
        if (shouldAllowEdits()) {
            let query = `/api/planCircuitBreakerDelete?planId=` + props.planId
            let result = await (await fetch(query, { method: 'POST' })).json();
            setResult(result);
            setUpdates(updates + 1);
        } else {
            setResult({ error: "Not allowed" });
        }
    }

    function updateLimit(index, field, value) {
        let newLimits = [...planLimits];
        newLimits[index][field] = value;
        setPlanLimits(newLimits);
    }

    function addLimit() {
        setPlanLimits([...planLimits, { symbol: '', limit_type: 'daily', limit: 0 }]);
    }

    function removeLimit(index) {
        let newLimits = [...planLimits];
        newLimits.splice(index, 1);
        setPlanLimits(newLimits);
    }

    async function saveLimits() {
        if (shouldAllowEdits()) {
            let query = `/api/planLimitsUpdate?planId=` + props.planId;
            let result = await (await fetch(query, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(planLimits)
            })).json();
            setResult(result);
            setUpdates(updates + 1);
        } else {
            setResult({ error: "Not allowed" });
        }
    }

    return (
        <>
            {planInfo ?
                <>
                    Is Enabled: <input type="checkbox" checked={planInfo.is_enabled} onChange={() => updateSetting("is_enabled", !planInfo.is_enabled)} />
                    <br></br>
                    DD Absolute Threshold: <input type="text" value={planInfo.dd_absolute_threshold} onChange={(e) => updateSetting("dd_absolute_threshold", e.target.value)} />&nbsp;<i>Negative Value</i>
                    <br></br>
                    DD Difference Start Threshold: <input type="text" value={planInfo.dd_difference_start_level} onChange={(e) => updateSetting("dd_difference_start_level", e.target.value)} />&nbsp;<i>Negative Value</i>
                    <br></br>
                    DD Difference Entry Threshold: <input type="text" value={planInfo.dd_difference_entry_threshold} onChange={(e) => updateSetting("dd_difference_entry_threshold", e.target.value)} />&nbsp;<i>Negative Value</i>
                    <br></br>
                    DD Difference Smoothing (Days): <input type="text" value={planInfo.dd_difference_smoothing_days} onChange={(e) => updateSetting("dd_difference_smoothing_days", e.target.value)} />&nbsp;<i># of days, 1 or above</i>
                    <br></br>
                    DD Difference Exit Threshold: <input type="text" value={planInfo.dd_difference_exit_threshold} onChange={(e) => updateSetting("dd_difference_exit_threshold", e.target.value)} />&nbsp;<i>0 or above</i>
                    <br></br>
                    Moving Average Entry Threshold: <input type="text" value={planInfo.moving_average_entry_threshold} onChange={(e) => updateSetting("moving_average_entry_threshold", e.target.value)} />&nbsp;<i>0 or above</i>
                    <br></br>
                    Exit On New High?: <input type="checkbox" checked={planInfo.should_exit_on_new_high} onChange={() => updateSetting("should_exit_on_new_high", !planInfo.should_exit_on_new_high)} />
                    <br></br>
                    Minimum days triggered: <input type="text" value={planInfo.minimum_triggered_days} onChange={(e) => updateSetting("minimum_triggered_days", e.target.value)} />&nbsp;<i>0 or above</i>
                    <br></br>
                    Scale Ratio: <input type="text" value={planInfo.scale_ratio} onChange={(e) => updateSetting("scale_ratio", e.target.value)} />&nbsp;<i>0.75 = 75%</i>
                    <br></br>
                    <br></br>
                    <button class="btn btn-primary" onClick={(e) => updateCircuitBreaker()}>Update</button>
                    <br></br>
                    <br></br>
                    <br></br>
                    <TwoStepConfirmationButton id={0} text="Delete Circuit Breaker" onConfirmed={removeCircuitBreaker} />
                </>
                :
                <>
                    No circuit breaker defined
                    <br></br>
                    <TwoStepConfirmationButton id={0} text="Add Circuit Breaker" onConfirmed={addCircuitBreaker} />
                </>
            }

            <br></br>
            <br></br>
            <h4>Plan Limits:</h4>
            <RichTable data={planLimits} className="table-striped table-hover table-condensed" mappers={[
                {
                    title: 'Symbol',
                    field: 'symbol',
                    formatter: (val, row) => <input type="text" className="form-control" value={val || ''} onChange={e => updateLimit(planLimits.indexOf(row), 'symbol', e.target.value)} />
                },
                {
                    title: 'Limit Type',
                    field: 'limit_type',
                    formatter: (val, row) => (
                        <select className="form-control" value={val || 'daily'} onChange={e => updateLimit(planLimits.indexOf(row), 'limit_type', e.target.value)}>
                            <option value="daily">Daily</option>
                            <option value="total">Total</option>
                        </select>
                    )
                },
                {
                    title: 'Limit',
                    field: 'limit',
                    formatter: (val, row) => <input type="number" className="form-control" value={val || 0} onChange={e => updateLimit(planLimits.indexOf(row), 'limit', parseFloat(e.target.value))} />
                },
                {
                    title: '',
                    field: '',
                    formatter: (val, row) => <button className="btn btn-danger btn-sm" onClick={() => removeLimit(planLimits.indexOf(row))}>Delete</button>
                }
            ]} />
            <br></br>
            <button className="btn btn-success" onClick={addLimit}>Add Limit</button>
            &nbsp;
            <button className="btn btn-primary" onClick={saveLimits}>Save Limits</button>
            <br></br>

            <ActionResult result={result} />
        </>
    );
}

export default CircuitBreaker;